export const RMark = ({ className = "h-5 w-5" }) => (
    <svg viewBox="0 0 24 24" className={className} aria-hidden="true" fill="none">
        <path d="M12 1.5 22.5 12 12 22.5 1.5 12Z" stroke="currentColor" strokeWidth="1.4" />
        <path d="M7.5 16.5 16.5 7.5" stroke="#E10600" strokeWidth="2" />
        <circle cx="12" cy="12" r="1.4" fill="#E10600" />
    </svg>
);
